<!--  -->
<template>
  <div>
    <div class="table-top">
      <el-button v-if="!disabled" @click="addRow">添加一行</el-button>
    </div>
    <vxe-table border align="center" size="mini" :data="tableData" :edit-config="{ trigger: 'click', mode: 'row' }">
      <vxe-column align="center" title="序号" type="seq" width="60" />
      <vxe-column field="continuousSignTime" title="连续签到天数">
        <template #default="{ row }">
           <el-input-number @change='changeEvent' v-model="row.continuousSignTime" :min="0"></el-input-number>
        </template>
      </vxe-column>
      <vxe-column field="integral" title="获得积分">
        <template #default="{ row }">
            <el-input-number @change='changeEvent' v-model="row.integral" :min="0"></el-input-number>
        </template>
      </vxe-column>
      <vxe-column v-if="!disabled" title="操作" show-overflow width="80">
        <template #default="{ row }">
          <el-button type="danger" @click="removeEvent(row)" icon="el-icon-delete" circle></el-button>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      tableData: [],
    };
  },
  computed: {},
  created() {

  },
  mounted() { },
  methods: {

    removeEvent(row) {
      this.tableData = this.tableData.filter((item) => item.id !== row.id);
      this.changeEvent();
    },
    addRow() {
      this.tableData.push({
        integral: '',
        continuousSignTime: '',
        id: new Date().getTime() + Math.random() * 10000,
      });
      this.changeEvent();
    },
    changeEvent() {
      this.$emit('change', this.tableData);
      this.$emit('input', this.tableData);
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        this.tableData = val
          ? val.map((el) => ({
            ...el,
            id: el.id || new Date().getTime() + Math.random() * 10000,
          }))
          : [];
      },
    },
  },
};
</script>

<style scoped lang="less">
.table-top {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

/deep/.vxe-header--column .vxe-cell--title {
  line-height: inherit !important;
}
</style>
